export const makeObjectFromString = (str: string, parentObject: any) => {
  const object = str.split(".").reduce(function (o, k) {
    return o && o[k];
  }, parentObject);

  return Array.isArray(object) ? object[0] : object;
};
